// Flag to prevent multiple simultaneous load requests
let isLoading = false;

// Store observer reference to properly disconnect it
let currentObserver = null;

const loadItems = (button) => {
  // Prevent multiple simultaneous requests
  if (isLoading) return;
  isLoading = true;

  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const rawValue = $('[data-next-url]').val();

  const getUrlWithoutPhcursor = (value, pageValue) => {
    const url = new URL(value, window.location.origin);
    url.searchParams.set('page', pageValue);
    url.searchParams.delete('phcursor');
    return url.pathname + '?' + url.searchParams.toString();
  }

  const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage)
  const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      // Запоминаем текущую позицию прокрутки
      const currentScrollTop = $(window).scrollTop();

      // Get new items from response
      const newItems = $(responseHTML).find('.load-more-grid').children();
      const existingGrid = $('.load-more-grid');

      // Get existing product IDs to prevent duplicates
      const existingIds = new Set();
      existingGrid.find('.collection-grid-card').each(function () {
        const productCard = $(this).find('[data-product-id]');
        if (productCard.length) {
          existingIds.add(productCard.data('product-id'));
        }
        // Fallback: use the product URL as identifier
        const productLink = $(this).find('a[href*="/products/"]');
        if (productLink.length) {
          existingIds.add(productLink.attr('href'));
        }
      });

      // Filter out duplicates before appending
      newItems.each(function () {
        const $item = $(this);
        const productCard = $item.find('[data-product-id]');
        const productLink = $item.find('a[href*="/products/"]');

        let isDuplicate = false;

        if (productCard.length && existingIds.has(productCard.data('product-id'))) {
          isDuplicate = true;
        }
        if (productLink.length && existingIds.has(productLink.attr('href'))) {
          isDuplicate = true;
        }

        // Only append if not a duplicate
        if (!isDuplicate) {
          existingGrid.append($item);
        }
      });

      colorSwatches();

      // Восстанавливаем предыдущую позицию прокрутки
      $(window).scrollTop(currentScrollTop);
    },
    complete: function () {
      isLoading = false; // Reset loading flag

      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
          scollData.querySelector('input[data-current-page]').value = currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    },
    error: function () {
      isLoading = false; // Reset loading flag on error
      button.removeAttribute("disabled");
      button.classList.remove('loading');
    }
  });
}

const checkVisibility = () => {
  // Disconnect previous observer if exists to prevent multiple triggers
  if (currentObserver) {
    currentObserver.disconnect();
    currentObserver = null;
  }

  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoading) {
            // Disconnect immediately after triggering to prevent double-firing
            observer.disconnect();
            loadItems(spinner);
          }
        })
      },
      { threshold: 0.1 } // Add threshold for more reliable triggering
    );

    currentObserver = sectionObserver;
    sectionObserver.observe(spinner);
  });
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();

